import dayjs from "dayjs";

import { Query } from "../types/firebase.types";
import { GenericFunction } from "../types/generic.types";
import { upperCaseFirstLetter } from "./generic";

export const stringHasContent = (): GenericFunction => {
  return (str: string): string | undefined => (str ? (str.trim() ? undefined : "Cannot be empty") : undefined);
};

export const int = (): GenericFunction => {
  return (num: number): string | undefined => (Number.isInteger(Number(num)) ? undefined : "Can't have decimal places");
};

export const isPhoneNumber = (type: string | null = null) => {
  return (phone: string): string | undefined => {
    const qa = /^\d{8}$/;
    const isValid = !!phone.match(qa);
    return isValid ? undefined : `Invalid ${type || "phone"} number`;
  };
};

export const isExists: (data: {
  query: (key: string, value: string) => Query;
  type: string;
  currentValue?: string;
  prefix?: string;
}) => (value: string) => Promise<string | undefined> = ({ query, type, currentValue, prefix }) => {
  let prefixedCurrentValue = currentValue;
  if (prefix) prefixedCurrentValue = prefix + currentValue;
  return async (value): Promise<string | undefined> => {
    let prefixedValue = value;
    if (prefix) prefixedValue = prefix + value;

    if (prefixedValue !== prefixedCurrentValue) {
      try {
        const snapshot = await query(type, prefixedValue).get();
        return snapshot.empty ? undefined : `${upperCaseFirstLetter(type)} already exists, pick up another!`;
      } catch (ex: any) {
        console.log(ex.message);
        return `Could not check ${type}`;
      }
    }
    return undefined;
  };
};

export const validateFileSize = (source: string, maxSize = 10) => {
  return (entry: any) => {
    if (Array.isArray(entry))
      return entry.some((img: any) => (img && img.rawFile ? img.rawFile.size > maxSize * 1024 * 1000 : false))
        ? `Maximum uploaded ${source} size is ${maxSize}mb`
        : undefined;
    else if (entry.rawFile)
      return entry.rawFile.size > maxSize * 1024 * 1000 ? `Maximum uploaded ${source} size is ${maxSize}mb` : undefined;
    return undefined;
  };
};

export const validateFilesCount = (source: string, maxFiles = 10) => {
  return (entry: any) => {
    if (Array.isArray(entry)) return entry.length > maxFiles ? `Maximum number of ${source} is ${maxFiles}` : undefined;

    return undefined;
  };
};

export function isDateIsOrAfterToday() {
  return (date: Date) => {
    return dayjs(date).isBefore(dayjs().startOf("day")) ? "Date can't be in the past" : undefined;
  };
}

export const isGreaterThan = (source: string, message: string | undefined) => {
  return (value: any, updatedRecord: any) => {
    return value > updatedRecord[source] ? undefined : message ?? `Value should be greater than ${source}`;
  };
};

export const isSmallerThan = (source: string, message: string | undefined) => {
  return (value: any, updatedRecord: any) => {
    return value < updatedRecord[source] ? undefined : message ?? `Value should be less than ${source}`;
  };
};

export const validateIsIntegerNumber = () => {
  return (value: any) => {
    return Number.isInteger(value) ? "" : "Max Players number mustn't includes '.'";
  };
};
